/**
 * Copyright (C) 2021 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import StyledViewHeader from './StyledViewHeader';

const ViewHeader = (props: { children: any; hidden?: boolean }) => {
  const { children, hidden } = props;

  if (hidden) {
    return null;
  }

  return (
    <StyledViewHeader position="relative">
      <Toolbar disableGutters className="viewheader">
        {children}
      </Toolbar>
    </StyledViewHeader>
  );
};

export default ViewHeader;
